import styled from "styled-components";

export const LibraryActionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;